import { render, staticRenderFns } from "./VillageV2AdjustmentForm.vue?vue&type=template&id=103e8e3e"
import script from "./VillageV2AdjustmentForm.vue?vue&type=script&lang=js"
export * from "./VillageV2AdjustmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports